export default __webpack_public_path__ + "static/media/British_Council.e325330d.png";